import React, { useState } from 'react';
import classNames from 'classnames';
import { ChevronDownOutlined } from 'jl-design-system/components/icons/ChevronDownOutlined';
import { sendEvent } from '@JohnLewisPartnership/experiments-utils';
import { PrenavMenu } from '../ui/prenav-menu/PrenavMenu';
import styles from './prenav-link.scss';
import { notifyNavAnalytics } from '../navigation/notify-analytics';

interface PrenavLinkProps {
  url?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  children?: React.ReactNode;
  menuLinks?: Array<{
    name?: string;
    url: string;
    external?: boolean;
  }>;
  itemClassName?: string;
  onClose?: () => void;
  external?: boolean;
}

export const PrenavLink = (props: PrenavLinkProps) => {
  const clickHandler = (e: React.MouseEvent<HTMLElement>) => {
    if (props.menuLinks?.length > 0) {
      e.preventDefault();
      return;
    }
    sendEvent(
      `prenav-menu-click.${(e.target as HTMLElement).innerHTML.replace(/ /g, '-').toLowerCase()}`
    );
    notifyNavAnalytics('pn', (e.target as HTMLElement).innerHTML);
    if (props.onClick) props.onClick(e);
  };

  const [showmenu, setShowmenu] = useState(false);

  const Element = props.url ? 'a' : 'button';

  return (
    <li
      className={classNames(
        styles.headerLinksContainer,
        styles.headerLinksContainer__prenav
      )}
      data-testid="prenav-redesign-container"
      onMouseEnter={() => setShowmenu(true)}
      onMouseLeave={() => setShowmenu(false)}
    >
      <>
        <Element
          className={classNames(
            styles.headerLinkItem,
            styles.headerLinkItem__prenav
          )}
          {...(props.url && { href: props.url })}
          {...(!props.url && { type: 'button' })}
          tabIndex={props.children ? 0 : -1}
          onClick={clickHandler}
          onKeyDown={e => {
            if (
              props.menuLinks?.length > 0 &&
              (e.key === 'Enter' || e.key === ' ')
            ) {
              e.preventDefault();
              setShowmenu(prev => !prev);
            }
          }}
          {...(props.menuLinks?.length > 0 && {
            'aria-haspopup': 'true',
            'aria-expanded': showmenu,
            'aria-controls': 'prenav-menu',
          })}
        >
          {props.children}
          {props.menuLinks?.length > 0 && (
            <ChevronDownOutlined
              className={styles.menuChevronIcon}
              size="small"
            />
          )}
        </Element>
        {showmenu && props.menuLinks?.length > 0 && (
          <PrenavMenu
            {...props}
            itemClassName={classNames(styles.prenavLinkMenuBox, {
              [styles.prenavLinkMenuBox__prenav]: true,
            })}
            onClose={() => setShowmenu(false)}
          />
        )}
      </>
    </li>
  );
};
